import { getFileSize } from '@surglogs/util'

// 31457280 bytes = 30 MB - configured in AWS S3 bucket, we need to change it together with API, not just here
export const FILE_UPLOAD_SIZE_LIMIT = getFileSize({ size: 30, unit: 'mb' })
